<!-- -->
<template>
<!--    <div class="btn-div">
      <div @click="changeLanguage(option.value)"
           :class="{active:selectValue==option.value}"
           v-for="option in options" class="btn-l">
        {{option.label}}
      </div>
    </div>-->
  <el-radio-group v-if="options&&options.length>0" @change="changeLanguage" v-model="selectValue"  ref="simpleDict">
    <el-radio-button v-if="!(item&&item.value=='')" v-for="item in options"
                     :key="item.value"
              :label="item.value"
    >
      {{item.label}}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
  export default {
    props:{
      dictType:{
        type:String,
        default:"language"
      },
      initOptions:{
        type:Array,
      },
      value:{
        type:String|Number,
      },
      data:{
        type:Object
      }
    },
    name: "simple-btn",
    data() {
      return {
        selectValue:0,
      }
    },
    watch:{
      value(){
        this.selectValue = this.value  || 0;
      }
    },
    computed:{
      options(){
        if(this.initOptions){
          return this.initOptions;
        }
        let op = this.$store.state.dictMap[this.dictType];
        if(op){
          let list =  this.copyDeepObj(op);
          if(this.data){
            list.push(this.data);
          }
          return list;
        }else{
          return op;
        }
      }
    },
    mixins: [tableBase],
    methods: {
      changeLanguage(value){
        this.selectValue = value;
        this.$emit('change',value);
        this.$emit('update:modelValue',value);
      }
    },
    mounted() {
      this.selectValue = this.value || 0;
    }
  }
</script>

<style lang="less" scoped>
.btn-div{
  display: flex;
  height: 32px;
  align-items: center;
  .btn-l{
    font-size: 12px;
    padding: 0px 10px;
    min-width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    margin-right: 10px;
    cursor: pointer;
    line-height: 28px;
    &.active{
      background-color:@primary;
      border:none;
      color: #FFF;
    }
  }
}
</style>
